import React, {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import { useRecoilState } from "recoil";
import { activeAutom } from "../../../../recoil-store/recoil-state";
import AppCredential from '../AppCredential/AppCredential';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';
import {Checkboxes} from "../../../FlowConfigurationInputs";

function SendMessage({ action, variables, setOpenVariable, automId, showAlert, automVersionId, automaticallyWhatsappVariableCreation }) {
    const [isQuestion, setIsQuestion] = useState(false);
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.MICROSOFT-TEAMS.SEND-MESSAGE.';
    const [automDetail, setAutomDetail] = useRecoilState(activeAutom);

    useEffect(() => {
        setIsQuestion(action.fields.isQuestion?.value);
        if (!action.fields.isQuestion?.value) {
            delete action.fields.set
        }
    }, [action.id])

    const changeIsQuestion = (status) => {
        setIsQuestion(status);
        if (status) {
            const variableSlug = `${action.actionName.toLowerCase().replaceAll('-', '')}_${action.item_id.replaceAll('-', '')}`
            const variableName = `##${action.actionName.toLowerCase().replaceAll('-', '')}_${action.item_id.replaceAll('-', '')}##`
            const variableAlreadyExists = variables.some(x => x.name === variableSlug)

            if (!variableAlreadyExists) {
                automaticallyWhatsappVariableCreation(action.item_id, action.actionName)
            }

            action.fields.set = {
                conditions: [],
                value: variableName
            }
        } else {
            delete action.fields.set
        }

    }


    return (
        <div>
            <AppCredential action={action} />

            <div className="form-element">
                <FieldLabel name={t(label + 'MESSAGE-NAME')} is_required />
                <TextInput action={action} inputName="message" variables={variables} setOpenVariable={setOpenVariable}
                    isRequired={true} multiline={true} fieldType='string' displayName={t(label + 'MESSAGE-NAME')} hideRequired />
            </div>
            <div className="form-element">
                <Checkboxes
                    action={action}
                    itemtype="app_connector"
                    inputName="isQuestion"
                    onChange={() => changeIsQuestion(!isQuestion)}
                    options={{ label: label + "IS-QUESTION" }}
                    isRequired={false}
                />
            </div>
            {isQuestion && (
                <div className="form-element">
                    {t(label + 'RESPONSE')}
                    <TextInput action={action} inputName="set" variables={variables} disabled={true}
                               setOpenVariable={setOpenVariable} rows={4} fieldType="string"
                               displayName={t(label + 'RESPONSE')} />
                </div>
            )}
        </div>
    );
}

export default SendMessage;
